/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Ti as Ti,
  rec_bS as bS,
  rec_ra as ra,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function CeldaCalendario(e) {
  let t = (0, ReactCompiler.c)(27),
    { celda: n, puedeCrear: r, onVer: i, onCrear: a, onCerrar: o } = e;
  if (!n) return null;
  let s = n.eventos.length,
    c;
  t[0] === n.clave
    ? (c = t[1])
    : ((c = bS(n.clave)), (t[0] = n.clave), (t[1] = c));
  let l = !c,
    u;
  t[2] === n.fecha
    ? (u = t[3])
    : ((u = n.fecha.toLocaleDateString(`es-PE`, {
        weekday: `long`,
        day: `numeric`,
        month: `long`,
      })),
      (t[2] = n.fecha),
      (t[3] = u));
  let d;
  t[4] === u
    ? (d = t[5])
    : ((d = (
        <span
          className={`text-sm font-medium capitalize text-(--text-h)`}
          children={u}
        />
      )),
      (t[4] = u),
      (t[5] = d));
  let f = s === 0 ? `sin nada agendado` : s === 1 ? `1 cosa` : `${s} cosas`,
    p = l && ` · ya pasó, solo se puede mirar`,
    m;
  t[6] !== f || t[7] !== p
    ? ((m = <span className={`text-xs text-(--text)`} children={[f, p]} />),
      (t[6] = f),
      (t[7] = p),
      (t[8] = m))
    : (m = t[8]);
  let h;
  t[9] !== n || t[10] !== s || t[11] !== i
    ? ((h = s > 0 && (
        <button
          type={`button`}
          onClick={() => i(n)}
          className={zo}
          children={`Ver el día`}
        />
      )),
      (t[9] = n),
      (t[10] = s),
      (t[11] = i),
      (t[12] = h))
    : (h = t[12]);
  let _;
  t[13] !== a || t[14] !== r
    ? ((_ = r && (
        <button
          type={`button`}
          onClick={a}
          className={zo}
          children={[
            <Ti className={`mr-1 inline h-3.5 w-3.5`} />,
            ` Agendar acá`,
          ]}
        />
      )),
      (t[13] = a),
      (t[14] = r),
      (t[15] = _))
    : (_ = t[15]);
  let v;
  t[16] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((v = (0, JSXRuntime.jsx)(ra, {
        className: `h-4 w-4`,
      })),
      (t[16] = v))
    : (v = t[16]);
  let y;
  t[17] === o
    ? (y = t[18])
    : ((y = (
        <button
          type={`button`}
          onClick={o}
          aria-label={`Quitar la marca del día`}
          className={`rounded-lg p-1.5 text-(--text) transition hover:bg-(--bg) hover:text-(--text-h)`}
          children={v}
        />
      )),
      (t[17] = o),
      (t[18] = y));
  let b;
  t[19] !== y || t[20] !== h || t[21] !== _
    ? ((b = (
        <span
          className={`ml-auto flex flex-wrap items-center gap-2`}
          children={[h, _, y]}
        />
      )),
      (t[19] = y),
      (t[20] = h),
      (t[21] = _),
      (t[22] = b))
    : (b = t[22]);
  let x;
  return (
    t[23] !== b || t[24] !== d || t[25] !== m
      ? ((x = (
          <div
            className={`animar-entrada flex flex-wrap items-center gap-2 rounded-2xl border border-(--accent-border) bg-(--accent-bg) px-3 py-2`}
            children={[d, m, b]}
          />
        )),
        (t[23] = b),
        (t[24] = d),
        (t[25] = m),
        (t[26] = x))
      : (x = t[26]),
    x
  );
}
